import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

function BenefitsCard(props: IBenefitsCard) {
  const { title, img, text, as } = props;

  let imgProps;
  let Text;

  if (typeof img === "object") {
    imgProps = { ...img };
  } else {
    imgProps = {
      src: img,
    };
  }

  if (Array.isArray(text)) {
    Text = text.map((e, index) => <CardText key={index}>{e}</CardText>);
  } else {
    Text = <CardText>{text}</CardText>;
  }

  return (
    <Wrapper as={as}>
      <CardHeader>
        <CardLogo>
          {/* Colorize external SVGs/PNGs by masking and applying background color */}
          {imgProps?.src ? (
            <span
              role="img"
              aria-label={imgProps?.alt || title}
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                backgroundColor: "#000e35",
                WebkitMaskImage: `url(${imgProps.src})`,
                maskImage: `url(${imgProps.src})`,
                WebkitMaskRepeat: "no-repeat",
                maskRepeat: "no-repeat",
                WebkitMaskPosition: "center",
                maskPosition: "center",
                WebkitMaskSize: "contain",
                maskSize: "contain",
              }}
            />
          ) : (
            <img {...imgProps} />
          )}
        </CardLogo>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardBody>{Text}</CardBody>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  row-gap: 1rem;
  min-height: 250px;
  max-width: 350px;

  @media (max-width: 768px) {
    min-height: 150px;
    margin: 1rem 0;
  }
`;

const CardHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const CardTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  text-transform: none;
  white-space: nowrap;
  margin: 0;
  @media (max-width: 768px) {
    text-align: center;
    justify-content: center;
  }
`;

const CardLogo = styled.div`
  width: 70px;
  height: 70px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: none; /* masked element above provides the visual */
  }
`;

const CardBody = styled.div`
  width: 100%;
  align-self: stretch;
  padding-right: 1.5rem;
  @media (max-width: 768px) {
    padding: 0 2.3rem;
    text-align: left;
  }
  @media (max-width: 568px) {
    padding: 0 1rem;
    text-align: left;
  }
`;

const CardText = styled.p`
  font-size: 0.938rem;
  color: #616161;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 15px;
  width: 100%;
`;

interface IBenefitsCard {
  title: string;
  img: ImageShape | string;
  text: string | Array<string>;
  as: React.ElementType;
}

interface ImageShape {
  src: string | undefined;
  alt?: string;
}

export default BenefitsCard;
